<template>
    <div class="excel-down-load" @click="clickHandler">
        {{ data.value }}
    </div>
</template>
<script>
export default {
    name: "ExcelDownColumn",
    props: ["data"],
    methods: {
        clickHandler() {
            this.$emit("colClick");
        }
    },
}
</script>
<style lang="less" scoped>
.excel-down-load {
    color: #409EFF;
    font-size: 14px;
    &:hover {
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>
